<template>
    <label class="relative inline-flex cursor-pointer items-center">
        <input type="checkbox" value="" class="peer sr-only" :checked="checked" @change="$emit('toggle')">
        <span class="peer h-4 w-11 rounded-full bg-gray-100 after:absolute after:left-[2px] after:top-[2px] after:h-3 after:w-3 after:rounded-full after:border after:border-gray-300 after:bg-pink after:transition-all after:content-[''] peer-checked:after:translate-x-7"></span>
    </label>
</template>
<script>
export default {
    name: "AtomToggle",
    props: {
        checked: {
            type: Boolean,
            default: true
        }
    }
}
</script>
